import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _defaultTo from 'lodash/defaultTo';
/* eslint-disable react/no-multi-comp, react/prefer-stateless-function */
import React, { Component } from 'react';
import PropTypes from 'prop-types';


import { Consumer } from '../context';
import { defaultTheme, themes } from '../constants';

var ThemeConsumer = function (_Component) {
  _inherits(ThemeConsumer, _Component);

  function ThemeConsumer() {
    _classCallCheck(this, ThemeConsumer);

    return _possibleConstructorReturn(this, (ThemeConsumer.__proto__ || _Object$getPrototypeOf(ThemeConsumer)).apply(this, arguments));
  }

  _createClass(ThemeConsumer, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return React.createElement(
        Consumer,
        null,
        function (theme) {
          return _this2.props.children(_defaultTo(theme, _this2.props.defaultTheme));
        }
      );
    }
  }]);

  return ThemeConsumer;
}(Component);

ThemeConsumer.propTypes = {
  /**
   *  - Themes:
   *     - light,
   *     - dark,
   */
  defaultTheme: PropTypes.oneOf(themes),
  /** The ThemeConsumer's children */
  children: PropTypes.func.isRequired
};
ThemeConsumer.defaultProps = {
  defaultTheme: defaultTheme
};
export default ThemeConsumer;